const SCOPE = {
  canGetAnyPlatformAdminAccount: 'GET_ANY_PLATFORM_ADMIN_ACCOUNT',
  canGetAnyEstablishmentAdminAccount: 'GET_ANY_ESTABLISHMENT_ADMIN_ACCOUNT',
  canGetAnyEstablishmentAdminAccountOOE: 'GET_ANY_ESTABLISHMENT_ADMIN_ACCOUNT_OF_OWN_ESTABLISHMENT',
};

export default SCOPE;
